import {signal} from "@preact/signals-react";

export const tags = signal([])
export const pageCategory = signal([])
export const pageProductType = signal([])
export const resourceType = signal([])
export const deviceType = signal('')
export const sectionCategory = signal([])

